import { useState, useEffect } from "react";

import {
  getUserSummaries,
  createSchool,
  createUser,
} from "../utils/firebaseUtils";
import { useNavigate } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme();

const capitalizeFirstLetter = (str: string): string => {
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
}

export const ExportToExcel = (data: any) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const makeData = (dataPassed: any): any[] => {
    let retData: any[] = [];
    console.log(dataPassed)
    dataPassed.forEach((datum: any) => {
      let a = {
        firstName: datum.firstName,
        lastName: datum.lastName,
        email: datum.email,
        amSession1: datum.amOne,
        amSession2: datum.amTwo,
        amSession3: datum.amThree,
        amSession4: datum.amFour,
        pmSession1: datum.pmOne,
        pmSession2: datum.pmTwo,
        pmSession3: datum.pmThree,
        pmSession4: datum.pmFour,
      };
      retData.push(a);
    });
    return retData;
  };

  const exportToCSV = (apiData: any, fileName: any) => {
    let apiData_ = makeData(apiData);
    console.log(apiData_);
    let data_ = JSON.stringify(apiData_);
    console.log(data_);
    const ws = XLSX.utils.json_to_sheet(JSON.parse(data_));
    console.log(ws);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button onClick={(e) => exportToCSV(data.data.apiData, data.data.fileName)}>
      Export as Excel File
    </Button>
  );
};

export const ExportPwdsToExcel = (data: any) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const makeData = (dataPassed: any): any[] => {
    let retData: any[] = [];
    console.log(dataPassed)
    dataPassed.forEach((datum: any) => {
      let a = {
        firstName: datum.firstName,
        lastName: datum.lastName,
        email: datum.email,
        password: datum.password,
      };
      retData.push(a);
    });
    return retData;
  };

  const exportToCSV = (apiData: any, fileName: any) => {
    let apiData_ = makeData(apiData);
    console.log(apiData_);
    let data_ = JSON.stringify(apiData_);
    console.log(data_);
    const ws = XLSX.utils.json_to_sheet(JSON.parse(data_));
    console.log(ws);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Button onClick={(e) => exportToCSV(data.data.apiData, data.data.fileName)}>
      Export as Excel File
    </Button>
  );
};

interface props {
  user: any;
  setUser: Function;
}

function Admin({ user, setUser }: props) {
  let navigate = useNavigate();

  const [summaries, setSummaries] = useState<any[]>([]);
  const [userPwds, setUserPwds] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState<number>(5);

  const [schoolName, setSchoolName] = useState("");
  const [category, setCategory] = useState("");
  const [time, setTime] = useState("");
  const [message, setMessage] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!user.admin) {
      navigate("/", { replace: true });
    }
    const getSummaries = async () => {
      return await getUserSummaries();
    };
    getSummaries().then((summary) => {
      setSummaries(summary.users);
      setUserPwds(summary.userPwds)
      console.log(summary);
    });
  }, []);

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 50 },
    {
      field: "firstName",
      headerName: "First name",
      width: 150,
    },
    {
      field: "lastName",
      headerName: "Last name",
      width: 150,
    },
    {
      field: "email",
      headerName: "Email",
      width: 150,
    },
    {
      field: "amOne",
      headerName: "AM Session One",
      width: 150,
    },
    {
      field: "amTwo",
      headerName: "AM Session Two",
      width: 150,
    },
    {
      field: "amThree",
      headerName: "AM Session Three",
      width: 150,
    },
    {
      field: "amFour",
      headerName: "AM Session Four",
      width: 150,
    },
    {
      field: "pmOne",
      headerName: "PM Session One",
      width: 150,
    },
    {
      field: "pmTwo",
      headerName: "PM Session Two",
      width: 150,
    },
    {
      field: "pmThree",
      headerName: "PM Session Three",
      width: 150,
    },
    {
      field: "pmFour",
      headerName: "PM Session Four",
      width: 150,
    },
  ];


  const pwdCols: GridColDef[] = [
    { field: "id", headerName: "ID", width: 50 },
    {
      field: "firstName",
      headerName: "First name",
      width: 150,
    },
    {
      field: "lastName",
      headerName: "Last name",
      width: 150,
    },
    {
      field: "email",
      headerName: "Email",
      width: 150,
    },
    {
      field: "password",
      headerName: "Password",
      width: 150,
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          backgroundImage:
            "linear-gradient(217deg, rgba(234,4,2,.8), rgba(3,234,45,0) 70.71%), linear-gradient(127deg, rgba(2,34,64,.8), rgba(0,233,111,0) 70.71%), linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%)",
          backgroundRepeat: "repeat",
          backgroundSize: "100%",
        }}
      >
        <Container component="main" maxWidth="md">
          <div style={{ height: 24 }} />
          <Card sx={{ minWidth: 275 }}>
            <div style={{ paddingTop: 20, paddingBottom: 20 }}>
              <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <Grid container>
                  <Grid item xs>
                    <Typography variant="h5" component="h3">
                      Admin Panel
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Button
                      onClick={() => {
                        navigate("/", { replace: true });
                      }}
                    >
                      {"Back to Main"}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Card>
          <div style={{ height: 24 }} />
          <Card sx={{ minWidth: 275 }}>
            <div style={{ paddingTop: 20, paddingBottom: 20 }}>
              <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <Typography variant="h5" component="h3">
                  Add New Student
                </Typography>
              </div>
              <Box
                component="form"
                noValidate
                sx={{
                  mt: 1,
                  width: "80%",
                  paddingLeft: "10%",
                  paddingRight: "10%",
                }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  name="firstName"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email"
                  name="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
                <Button
                  fullWidth
                  variant="contained"
                  disabled={
                    firstName.length < 1 ||
                    lastName.length < 1 ||
                    email.length < 1
                  }
                  sx={{ mt: 3, mb: 2 }}
                  onClick={async () => {
                    const student = {
                      firstName: capitalizeFirstLetter(firstName),
                      lastName: capitalizeFirstLetter(lastName),
                      email: email.toLowerCase(),
                    };
                    const ret = await createUser(student);
                    alert(`User Created with password ${ret}`);
                  }}
                >
                  Create
                </Button>
              </Box>
              {message.length > 5 && (
                <Typography sx={{ color: "blue" }}>{message}</Typography>
              )}
            </div>
          </Card>
          <div style={{ height: 24 }} />
          <Card sx={{ minWidth: 275 }}>
            <div style={{ paddingTop: 20, paddingBottom: 20 }}>
              <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <Typography variant="h5" component="h3">
                  Add New School
                </Typography>
              </div>
              <Box
                component="form"
                noValidate
                sx={{
                  mt: 1,
                  width: "80%",
                  paddingLeft: "10%",
                  paddingRight: "10%",
                }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="schoolName"
                  label="School Name"
                  name="schoolName"
                  value={schoolName}
                  onChange={(e) => {
                    setSchoolName(e.target.value);
                  }}
                />
                <div style={{ height: 12 }} />
                <FormControl fullWidth>
                  <InputLabel id="category-label">Category</InputLabel>
                  <Select
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    label="Category"
                  >
                    <MenuItem value="In-State">In-State</MenuItem>
                    <MenuItem value="Out-Of-State">Out-Of-State</MenuItem>
                    <MenuItem value="DO">DO</MenuItem>
                  </Select>
                </FormControl>
                <div style={{ height: 16 }} />
                <FormControl fullWidth>
                  <InputLabel id="time-label">Time</InputLabel>
                  <Select
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                    label="Time"
                  >
                    <MenuItem value="AM">AM</MenuItem>
                    <MenuItem value="PM">PM</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  fullWidth
                  variant="contained"
                  disabled={
                    schoolName.length < 1 ||
                    category.length < 1 ||
                    time.length < 1
                  }
                  sx={{ mt: 3, mb: 2 }}
                  onClick={async () => {
                    const school = {
                      schoolName,
                      category,
                      time,
                    };
                    console.log(school);
                    const ret = await createSchool(school);
                    setMessage(ret.message);
                  }}
                >
                  Create
                </Button>
              </Box>
              {message.length > 5 && (
                <Typography sx={{ color: "blue" }}>{message}</Typography>
              )}
            </div>
          </Card>
          <div style={{ height: 24 }} />
          <Card sx={{ minWidth: 275 }}>
            <div style={{ paddingTop: 20, paddingBottom: 20 }}>
              <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <Typography variant="h5" component="h3">
                  Student Data
                </Typography>
              </div>
              <div style={{ height: 400, width: "95%", padding: 20 }}>
                <DataGrid
                  rows={summaries}
                  columns={columns}
                  pageSize={pageSize}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  rowsPerPageOptions={[5, 10, 20]}
                  checkboxSelection
                  disableSelectionOnClick
                />
              </div>
              <div style={{ paddingLeft: 20 }}>
                <ExportToExcel
                  data={{ apiData: summaries, fileName: "students" }}
                />
              </div>
            </div>
          </Card>
          <div style={{ height: 24 }} />
          <Card sx={{ minWidth: 275 }}>
            <div style={{ paddingTop: 20, paddingBottom: 20 }}>
              <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <Typography variant="h5" component="h3">
                  Student Passwords
                </Typography>
              </div>
              <div style={{ height: 400, width: "95%", padding: 20 }}>
                <DataGrid
                  rows={userPwds}
                  columns={pwdCols}
                  pageSize={pageSize}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  rowsPerPageOptions={[5, 10, 20]}
                  checkboxSelection
                  disableSelectionOnClick
                />
              </div>
              <div style={{ paddingLeft: 20 }}>
                <ExportPwdsToExcel
                  data={{ apiData: userPwds, fileName: "user_passwords" }}
                />
              </div>
            </div>
          </Card>
        </Container>
      </div>
    </ThemeProvider>
  );
}

export default Admin;
